import { render, staticRenderFns } from "./dashboard-widget-context.vue?vue&type=template&id=2c137bde&"
import script from "./dashboard-widget-context.vue?vue&type=script&lang=js&"
export * from "./dashboard-widget-context.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports